import React, { useState } from 'react';
import styled from 'styled-components';
import { registry } from '../../core/Registry.js';

const Wrapper = styled.div`
  width: ${props => props.width || '100%'};
  max-width: 800px;
  margin: ${props => props.align === 'center' ? '0 auto' : (props.align === 'right' ? '0 0 0 auto' : '0')};
`;

const AccordionItem = styled.div`
  margin-bottom: 15px;
  background: var(--glass-1);
  border: 1px solid var(--glass-border);
  border-radius: 12px;
  overflow: hidden;
  backdrop-filter: blur(8px);
  transition: all 0.3s ease;

  ${props => props.isOpen && `
    border-color: var(--accent);
    box-shadow: 0 4px 20px rgba(6,182,212,0.1);
  `}
`;

const AccordionHeader = styled.div`
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  color: var(--text-primary);
  font-weight: 600;
  font-size: 16px;

  &:hover {
    color: var(--accent);
  }

  svg {
    width: 20px;
    height: 20px;
    transition: transform 0.3s;
    transform: ${props => props.isOpen ? 'rotate(180deg)' : 'rotate(0)'};
    color: ${props => props.isOpen ? 'var(--accent)' : 'var(--text-muted)'};
  }
`;

const AccordionContent = styled.div`
  padding: ${props => props.isOpen ? '0 20px 20px 20px' : '0 20px'};
  max-height: ${props => props.isOpen ? '500px' : '0'};
  opacity: ${props => props.isOpen ? '1' : '0'};
  overflow: hidden;
  transition: all 0.3s ease;
  color: var(--text-secondary);
  font-size: 14px;
  line-height: 1.6;
`;

const SupportFaqWidget = ({ node }) => {
  const [openIndex, setOpenIndex] = useState(0);

  const faqsRaw = node.content?.faqs || "Wann wird meine SIM-Karte freigeschaltet?|Die Freischaltung dauert im Regelfall maximal 24 Stunden nach Erhalt.||Kann ich meine Rufnummer mitnehmen?|Ja, das ist problemlos im Mein O2 Bereich möglich.";
  
  // Split manually created faqs: Question|Answer||Question|Answer
  const faqBlocks = faqsRaw.split('||').map(b => b.trim()).filter(Boolean);
  const faqs = faqBlocks.map(block => {
    const parts = block.split('|');
    return { q: parts[0] || 'Frage?', a: parts[1] || 'Antwort...' };
  });

  return (
    <Wrapper align={node.style?.desktop?.align} width={node.style?.desktop?.width}>
      <h3 style={{color: 'var(--text-primary)', marginBottom: '20px', fontSize: '22px'}}>Häufig gestellte Fragen</h3>
      {faqs.map((faq, i) => (
        <AccordionItem key={i} isOpen={openIndex === i}>
          <AccordionHeader isOpen={openIndex === i} onClick={() => setOpenIndex(openIndex === i ? -1 : i)}>
            {faq.q}
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M19 9l-7 7-7-7"></path></svg>
          </AccordionHeader>
          <AccordionContent isOpen={openIndex === i}>
            {faq.a}
          </AccordionContent>
        </AccordionItem>
      ))}
    </Wrapper>
  );
};

registry.register('support_faq', {
  label: 'FAQ Akkordeon',
  icon: '❓',
  category: 'tef_specific',
  defaultContent: { faqs: 'Wann erhalte ich mein iPhone?|Normalerweise in 3 Werktagen.||Wie erreiche ich den Support?|Hotline: 089 123 456' },
  defaultStyle: { desktop: { align: 'center', width: '100%' } },
  render: SupportFaqWidget,
  inspectorControls: [
    { tab: 'content', groups: [{ title: 'Inhalt', fields: [{name:'content.faqs', label:'FAQs (Format: Frage|Antwort||Frage|Antwort)', type:'textarea'}] }] },
    { tab: 'style', groups: [{ title: 'Layout', fields: [{name:'style.desktop.align', label:'Ausrichtung', type:'select', options:[{label:'Zentriert', value:'center'},{label:'Links', value:'flex-start'}]}, {name:'style.desktop.width', label:'Breite', type:'text'}] }] }
  ]
});
